import type { FaireProductEntity } from "../../entity_types/product";

export const p_ps3ufaemx5: FaireProductEntity = {
  token: "p_ps3ufaemx5",
  type: "product",
  name: "Lasso Wedding Rosary",
  brandToken: "b_mtptd58squ",
  brandName: "Christian Brands Catholic",
  imageUrl:
    "https://cdn.faire.com/fastly/5eeac57ede04c498eb4b833d640bc451e621d377166891db18d7072f49301aff.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67c10f9881738417a4f0b27ed6fc9bb483e9639f24854f7c034c4465beb25c6b.jpeg",
    "https://cdn.faire.com/fastly/252aa87c57adf9900ba130253cc0fb94538df0a1bca9937ee6e010098e2270ba.jpeg",
  ],
  priceDollars: 20.39,
  description:
    'A wedding lasso rosary, also called el lazo, is an oversized rosary, large enough to be entwined (lassoed) around the couple getting married. The "lassoing" act is widely used in Hispanic culture, a symbol of unifying the couple together in marriage for their entire lives, reminding them they share the responsibility of marriage and raising a family. The use of rosary beads in this ritual is also significant; using a rosary reflects that the bride and groom are forever bound together in unity by God. Comes in a beautiful gift box.\n\nMaterial: Gold Plated, Faceted Crystal Bead.\n\nSize: 10mm Ivory/Jet Faux Pearl Beads, Gold Plate, 4.25" Cross, .75" Centerpiece, 36"L Total.',
  tags: [],
  msrpDollars: 32.96,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:47.081Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
